// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falAnglesRight: CreateIconOptions = {
  "displayName": "FALAnglesRight",
  "viewBox": "0, 0, 512, 512",
  "d": "M443.9 266.7c5.5-6.1 5.5-15.3 0-21.4l-144-160c-5.9-6.6-16-7.1-22.6-1.2s-7.1 16-1.2 22.6L410.5 256 276.1 405.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2l144-160zm-336 160l144-160c5.5-6.1 5.5-15.3 0-21.4l-144-160c-5.9-6.6-16-7.1-22.6-1.2s-7.1 16-1.2 22.6L218.5 256 84.1 405.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2z"
};
